













import { Component, Vue, Inject } from 'vue-property-decorator'
// import advert from '@/components/Advert/Advert.vue'

@Component
export default class Cooperate extends Vue {
  loaded: boolean = false // 页面是否已经加载完成
  created () {
    this.loaded = true
  }
  scrollTop () {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    this.loaded = true
  }
  mounted () {
    this.scrollTop()
    console.log(this.loaded)
    Lib.dispatchEvent(document, 'custom-render-trigger')
  }
}
